export const ReactionsIcon = () => (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="18" cy="18.0007" r="13.1708" stroke="url(#paint0_linear_5064_3416)" strokeWidth="2.65833" />
        <path
            d="M21.996 20.4198C22.206 19.8571 22.8323 19.5712 23.3951 19.7811C23.9578 19.9911 24.2437 20.6175 24.0338 21.1802C23.0296 23.8713 20.9053 25.2708 17.8794 25.2708C14.8536 25.2708 12.7293 23.8713 11.7252 21.1802C11.5152 20.6175 11.8012 19.9911 12.3639 19.7811C12.9266 19.5712 13.553 19.8571 13.7629 20.4198C14.442 22.2399 15.7413 23.0958 17.8794 23.0958C20.0176 23.0958 21.3169 22.2399 21.996 20.4198Z"
            fill="url(#paint1_linear_5064_3416)"
            stroke="url(#paint2_linear_5064_3416)"
            strokeWidth="0.7"
        />
        <path
            d="M14.3651 12.0172C15.4607 12.0174 16.3485 12.906 16.3485 14.0016C16.3483 15.097 15.4605 15.9848 14.3651 15.985C13.2695 15.985 12.3809 15.0972 12.3807 14.0016C12.3807 12.9058 13.2694 12.0172 14.3651 12.0172ZM21.8759 12.0172C22.9714 12.0174 23.8593 12.906 23.8593 14.0016C23.859 15.097 22.9713 15.9848 21.8759 15.985C20.7802 15.985 19.8917 15.0972 19.8915 14.0016C19.8915 12.9058 20.7801 12.0172 21.8759 12.0172Z"
            fill="url(#paint3_linear_5064_3416)"
        />
        <path
            d="M14.3651 12.0172L14.3652 11.7672H14.3651V12.0172ZM16.3485 14.0016L16.5985 14.0016V14.0016H16.3485ZM14.3651 15.985V16.235H14.3652L14.3651 15.985ZM12.3807 14.0016H12.1307V14.0016L12.3807 14.0016ZM21.8759 12.0172L21.8759 11.7672H21.8759V12.0172ZM23.8593 14.0016L24.1093 14.0016V14.0016H23.8593ZM21.8759 15.985V16.235H21.8759L21.8759 15.985ZM19.8915 14.0016H19.6415V14.0016L19.8915 14.0016ZM14.3651 12.0172L14.3651 12.2672C15.3225 12.2674 16.0985 13.0439 16.0985 14.0016H16.3485H16.5985C16.5985 12.768 15.5989 11.7675 14.3652 11.7672L14.3651 12.0172ZM16.3485 14.0016L16.0985 14.0015C16.0983 14.9589 15.3225 15.7348 14.3651 15.735L14.3651 15.985L14.3652 16.235C15.5986 16.2347 16.5983 15.2351 16.5985 14.0016L16.3485 14.0016ZM14.3651 15.985V15.735C13.4074 15.735 12.6309 14.959 12.6307 14.0015L12.3807 14.0016L12.1307 14.0016C12.131 15.2354 13.1315 16.235 14.3651 16.235V15.985ZM12.3807 14.0016H12.6307C12.6307 13.0439 13.4074 12.2672 14.3651 12.2672V12.0172V11.7672C13.1313 11.7672 12.1307 12.7678 12.1307 14.0016H12.3807ZM21.8759 12.0172L21.8758 12.2672C22.8332 12.2674 23.6093 13.0439 23.6093 14.0016H23.8593H24.1093C24.1093 12.768 23.1096 11.7674 21.8759 11.7672L21.8759 12.0172ZM23.8593 14.0016L23.6093 14.0015C23.6091 14.9589 22.8332 15.7348 21.8758 15.735L21.8759 15.985L21.8759 16.235C23.1094 16.2347 24.109 15.2351 24.1093 14.0016L23.8593 14.0016ZM21.8759 15.985V15.735C20.9182 15.735 20.1417 14.959 20.1415 14.0015L19.8915 14.0016L19.6415 14.0016C19.6417 15.2354 20.6423 16.235 21.8759 16.235V15.985ZM19.8915 14.0016H20.1415C20.1415 13.0439 20.9182 12.2672 21.8759 12.2672V12.0172V11.7672C20.642 11.7672 19.6415 12.7678 19.6415 14.0016H19.8915Z"
            fill="url(#paint4_linear_5064_3416)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_5064_3416"
                x1="3.5"
                y1="3.50073"
                x2="33.2064"
                y2="31.7581"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#00CCFF" />
                <stop offset="1" stopColor="#3191FF" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5064_3416"
                x1="11.6563"
                y1="19.7122"
                x2="16.1554"
                y2="29.0855"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#00CCFF" />
                <stop offset="1" stopColor="#3191FF" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_5064_3416"
                x1="11.6563"
                y1="19.7122"
                x2="16.1554"
                y2="29.0855"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#00CCFF" />
                <stop offset="1" stopColor="#3191FF" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_5064_3416"
                x1="12.3807"
                y1="12.0172"
                x2="15.2514"
                y2="19.3533"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#00CCFF" />
                <stop offset="1" stopColor="#3191FF" />
            </linearGradient>
            <linearGradient
                id="paint4_linear_5064_3416"
                x1="12.3807"
                y1="12.0172"
                x2="15.2514"
                y2="19.3533"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#00CCFF" />
                <stop offset="1" stopColor="#3191FF" />
            </linearGradient>
        </defs>
    </svg>
)

export const CategoriesIcon = () => (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.7208 5.40039H8.24379C6.67457 5.40039 5.40021 6.67482 5.40021 8.24414V13.7215C5.40021 15.2874 6.67457 16.5652 8.24379 16.5652H13.7208C15.2901 16.5652 16.5644 15.2908 16.5644 13.7215V8.24414C16.5644 6.67482 15.2901 5.40039 13.7208 5.40039ZM15.0969 13.7215C15.0969 14.4807 14.48 15.0976 13.7208 15.0976H8.24379C7.4846 15.0976 6.86775 14.4807 6.86775 13.7215V8.24414C6.86775 7.4849 7.4846 6.86802 8.24379 6.86802H13.7208C14.48 6.86802 15.0969 7.4849 15.0969 8.24414V13.7215Z"
            fill="url(#paint0_linear_5064_3427)"
            stroke="url(#paint1_linear_5064_3427)"
            strokeWidth="1.16667"
        />
        <path
            d="M27.7564 5.40039H22.2794C20.7102 5.40039 19.4358 6.67482 19.4358 8.24414V13.7215C19.4358 15.2874 20.7102 16.5652 22.2794 16.5652H27.7564C29.3256 16.5652 30.6 15.2908 30.6 13.7215V8.24414C30.6 6.67482 29.3256 5.40039 27.7564 5.40039ZM29.1324 13.7215C29.1324 14.4807 28.5156 15.0976 27.7564 15.0976H22.2794C21.5202 15.0976 20.9033 14.4807 20.9033 13.7215V8.24414C20.9033 7.4849 21.5202 6.86802 22.2794 6.86802H27.7564C28.5156 6.86802 29.1324 7.4849 29.1324 8.24414V13.7215Z"
            fill="url(#paint2_linear_5064_3427)"
            stroke="url(#paint3_linear_5064_3427)"
            strokeWidth="1.16667"
        />
        <path
            d="M13.7206 19.4362H8.24361C6.67438 19.4362 5.40002 20.7107 5.40002 22.28V27.7573C5.40002 29.3232 6.67438 30.6011 8.24361 30.6011H13.7206C15.2899 30.6011 16.5642 29.3266 16.5642 27.7573V22.28C16.5642 20.7107 15.2899 19.4362 13.7206 19.4362ZM15.0967 27.7573C15.0967 28.5166 14.4798 29.1334 13.7206 29.1334H8.24361C7.48442 29.1334 6.86757 28.5166 6.86757 27.7573V22.28C6.86757 21.5207 7.48442 20.9038 8.24361 20.9038H13.7206C14.4798 20.9038 15.0967 21.5207 15.0967 22.28V27.7573Z"
            fill="url(#paint4_linear_5064_3427)"
            stroke="url(#paint5_linear_5064_3427)"
            strokeWidth="1.16667"
        />
        <path
            d="M27.7564 19.4362H22.2794C20.7102 19.4362 19.4358 20.7107 19.4358 22.28V27.7573C19.4358 29.3232 20.7102 30.6011 22.2794 30.6011H27.7564C29.3256 30.6011 30.6 29.3266 30.6 27.7573V22.28C30.6 20.7107 29.3256 19.4362 27.7564 19.4362ZM29.1324 27.7573C29.1324 28.5166 28.5156 29.1334 27.7564 29.1334H22.2794C21.5202 29.1334 20.9033 28.5166 20.9033 27.7573V22.28C20.9033 21.5207 21.5202 20.9038 22.2794 20.9038H27.7564C28.5156 20.9038 29.1324 21.5207 29.1324 22.28V27.7573Z"
            fill="url(#paint6_linear_5064_3427)"
            stroke="url(#paint7_linear_5064_3427)"
            strokeWidth="1.16667"
        />
        <defs>
            <linearGradient
                id="paint0_linear_5064_3427"
                x1="16.5644"
                y1="7.79226"
                x2="5.39989"
                y2="14.1728"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF6666" />
                <stop offset="1" stopColor="#E646B6" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5064_3427"
                x1="16.5644"
                y1="7.79226"
                x2="5.39989"
                y2="14.1728"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF6666" />
                <stop offset="1" stopColor="#E646B6" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_5064_3427"
                x1="30.6"
                y1="7.79226"
                x2="19.4355"
                y2="14.1728"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF6666" />
                <stop offset="1" stopColor="#E646B6" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_5064_3427"
                x1="30.6"
                y1="7.79226"
                x2="19.4355"
                y2="14.1728"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF6666" />
                <stop offset="1" stopColor="#E646B6" />
            </linearGradient>
            <linearGradient
                id="paint4_linear_5064_3427"
                x1="16.5642"
                y1="21.8281"
                x2="5.39971"
                y2="28.2086"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF6666" />
                <stop offset="1" stopColor="#E646B6" />
            </linearGradient>
            <linearGradient
                id="paint5_linear_5064_3427"
                x1="16.5642"
                y1="21.8281"
                x2="5.39971"
                y2="28.2086"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF6666" />
                <stop offset="1" stopColor="#E646B6" />
            </linearGradient>
            <linearGradient
                id="paint6_linear_5064_3427"
                x1="30.6"
                y1="21.8281"
                x2="19.4355"
                y2="28.2086"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF6666" />
                <stop offset="1" stopColor="#E646B6" />
            </linearGradient>
            <linearGradient
                id="paint7_linear_5064_3427"
                x1="30.6"
                y1="21.8281"
                x2="19.4355"
                y2="28.2086"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF6666" />
                <stop offset="1" stopColor="#E646B6" />
            </linearGradient>
        </defs>
    </svg>
)

export const AdvertiseIcon = () => (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_5064_3439)">
            <g clipPath="url(#clip1_5064_3439)">
                <path
                    d="M17.5355 31.4441C15.2691 32.2965 12.7586 31.0868 11.9337 28.7449L10.4676 24.5824L8.18954 24.6797C6.56575 24.7494 5.09494 23.7341 4.53862 22.1547L3.71266 19.8097C3.15528 18.2273 3.64766 16.4788 4.93873 15.4505L17.4761 5.45285C17.7631 5.22203 18.0794 5.04161 18.4192 4.9138C20.2335 4.23143 22.2463 5.20502 22.9066 7.07981L27.1602 19.1559C27.8205 21.0307 26.8843 23.1134 25.07 23.7958C24.7302 23.9236 24.3756 23.9955 24.0122 24.0093L19.6336 24.1969L20.1485 25.6588C20.9734 28.0007 19.8027 30.5949 17.5363 31.4473L17.5355 31.4441ZM13.4272 28.1832C13.9516 29.6722 15.551 30.4428 16.992 29.9009C18.4329 29.3589 19.1787 27.7063 18.6542 26.2173L17.9652 24.2611L12.1336 24.5105L13.4272 28.1832ZM23.944 22.3658C24.1435 22.3556 24.337 22.3187 24.5207 22.2496C25.5095 21.8777 26.0225 20.7409 25.661 19.7146L21.4075 7.63851C21.046 6.61219 19.9459 6.08215 18.9571 6.45404C18.7704 6.52425 18.5987 6.62296 18.443 6.7481L5.90564 16.7457C5.16656 17.3343 4.88626 18.3392 5.20423 19.2419L6.0302 21.5869C6.34977 22.4941 7.18795 23.0732 8.12026 23.0332L23.9435 22.3643L23.944 22.3658Z"
                    fill="url(#paint0_linear_5064_3439)"
                    stroke="url(#paint1_linear_5064_3439)"
                    strokeWidth="1.13527"
                />
                <path
                    d="M31.2588 14.9349L28.571 7.30411"
                    stroke="url(#paint2_linear_5064_3439)"
                    strokeWidth="2.90574"
                    strokeLinecap="round"
                />
            </g>
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_5064_3439"
                x1="21.7482"
                y1="4.55498"
                x2="-3.14189"
                y2="34.8381"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#9013FE" />
                <stop offset="1" stopColor="#E646B6" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5064_3439"
                x1="21.7482"
                y1="4.55498"
                x2="-4.09589"
                y2="35.2651"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#9013FE" />
                <stop offset="1" stopColor="#E646B6" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_5064_3439"
                x1="25.6428"
                y1="12.1283"
                x2="30.6721"
                y2="9.61098"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#6157FF" />
                <stop offset="1" stopColor="#9933FF" />
            </linearGradient>
            <clipPath id="clip0_5064_3439">
                <rect width="36" height="36" fill="white" transform="translate(0 0.000732422)" />
            </clipPath>
            <clipPath id="clip1_5064_3439">
                <rect width="34" height="34" fill="white" transform="translate(0.799805 0.400757)" />
            </clipPath>
        </defs>
    </svg>
)

export const CreateIcon = () => (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2784 4.64355L14.1665 4.64921C13.6144 4.70527 13.1836 5.17153 13.1836 5.7384V13.2263L5.69471 13.2272C5.09009 13.2272 4.59998 13.7174 4.59998 14.322V21.6794L4.60563 21.7913C4.6617 22.3435 5.12802 22.7743 5.69493 22.7742L13.1836 22.7725V30.263C13.1836 30.8677 13.6738 31.3578 14.2784 31.3578H21.6358L21.7478 31.3522C22.2998 31.2961 22.7307 30.8299 22.7307 30.263V22.7742H30.2194C30.8241 22.7742 31.3143 22.2841 31.3143 21.6794V14.322L31.3086 14.2101C31.2525 13.658 30.7863 13.2272 30.2194 13.2272H22.7307V5.7384C22.7307 5.13373 22.2405 4.64355 21.6358 4.64355H14.2784ZM20.541 6.83325V14.322L20.5466 14.434C20.6027 14.986 21.0689 15.4169 21.6358 15.4169H29.1246V20.5845H21.6358L21.5239 20.5902C20.9718 20.6463 20.541 21.1125 20.541 21.6794V29.1681H15.3733V21.6785L15.3676 21.5666C15.3116 21.0144 14.8452 20.5836 14.2783 20.5837L6.78967 20.5845V15.416H14.2785L14.3905 15.4103C14.9425 15.3542 15.3733 14.888 15.3733 14.3211V6.83325H20.541Z"
            fill="url(#paint0_linear_5064_3447)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_5064_3447"
                x1="17.9571"
                y1="34.09"
                x2="15.0732"
                y2="5.40249"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#00E6CC" />
                <stop offset="1" stopColor="#00FF99" />
            </linearGradient>
        </defs>
    </svg>
)

export const LoginIcon = () => (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.4471 19.7666C16.6993 20.4173 18.1338 20.7866 19.6584 20.7866C20.9773 20.7866 22.2287 20.5102 23.3529 20.0148L23.6563 19.8742C27.3072 21.4934 29.8533 25.146 29.8533 29.3924V30.0652H9V29.3924C9 25.1442 11.5483 21.4903 15.2019 19.8715L15.4471 19.7666ZM15.4715 22.2153L15.3701 22.2714C13.3727 23.4067 11.9391 25.3319 11.4288 27.5707L11.3707 27.8442H27.4813L27.4803 27.8353C27.0401 25.5576 25.6498 23.577 23.6706 22.3819L23.5664 22.321L23.2805 22.4218C22.2423 22.7688 21.1497 22.9657 20.0319 23.0016L19.6584 23.0076C18.3015 23.0076 16.9771 22.7707 15.7371 22.317L15.4715 22.2153ZM19.9232 4.20703C23.8543 4.20703 27.0411 7.38904 27.0411 11.3142C27.0411 15.1654 23.9734 18.3011 20.1449 18.4181L19.9232 18.4214C15.992 18.4214 12.8052 15.2394 12.8052 11.3142C12.8052 7.4631 15.8729 4.32737 19.7015 4.21041L19.9232 4.20703ZM19.9232 6.42803C17.2205 6.42803 15.0296 8.61566 15.0296 11.3142C15.0296 14.0128 17.2205 16.2004 19.9232 16.2004C22.6258 16.2004 24.8168 14.0128 24.8168 11.3142C24.8168 8.61566 22.6258 6.42803 19.9232 6.42803Z"
            fill="url(#paint0_linear_5064_3453)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_5064_3453"
                x1="10.5748"
                y1="33.5111"
                x2="36.1245"
                y2="2.26232"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF6666" />
                <stop offset="1" stopColor="#FFF35C" />
            </linearGradient>
        </defs>
    </svg>
)

export const MoreIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="24" viewBox="0 0 8 24" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.9653 6.44968C5.73027 6.44968 7.16107 5.03497 7.16107 3.28984C7.16107 1.54471 5.73027 0.130005 3.9653 0.130005C2.20033 0.130005 0.769531 1.54471 0.769531 3.28984C0.769531 5.03497 2.20033 6.44968 3.9653 6.44968ZM3.9653 15.0774C5.73027 15.0774 7.16107 13.6627 7.16107 11.9176C7.16107 10.1724 5.73027 8.75774 3.9653 8.75774C2.20033 8.75774 0.769531 10.1724 0.769531 11.9176C0.769531 13.6627 2.20033 15.0774 3.9653 15.0774ZM3.9653 23.87C5.73027 23.87 7.16107 22.4553 7.16107 20.7102C7.16107 18.965 5.73027 17.5503 3.9653 17.5503C2.20033 17.5503 0.769531 18.965 0.769531 20.7102C0.769531 22.4553 2.20033 23.87 3.9653 23.87Z"
            fill="white"
        />
    </svg>
)

export const CaretIcon = ({ rotated = false, ...props }: { rotated?: boolean } & React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="8"
        transform="rotate(180)"
        viewBox="0 0 13 8"
        fill="none"
        style={{
            transform: rotated ? 'rotate(360deg)' : undefined,
            transition: 'transform 0.2s cubic-bezier(.4,0,.2,1)',
        }}
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.3047 5.74744C12.3047 5.69619 12.2819 5.64495 12.2364 5.5937L6.65071 0.561494C6.60136 0.520498 6.54253 0.5 6.4742 0.5C6.40588 0.5 6.34704 0.520498 6.29769 0.561494L0.712042 5.5937C0.662695 5.6347 0.638021 5.6868 0.638021 5.75C0.638021 5.8132 0.662695 5.8653 0.712042 5.9063L2.4145 7.43851C2.46005 7.4795 2.51794 7.5 2.58816 7.5C2.65838 7.5 2.71627 7.4795 2.76182 7.43851L6.4742 4.09736L10.1866 7.43851C10.2321 7.4795 10.29 7.5 10.3602 7.5C10.4305 7.5 10.4884 7.4795 10.5339 7.43851L12.2364 5.9063C12.2819 5.85505 12.3047 5.8021 12.3047 5.74744Z"
            fill="white"
        />
    </svg>
)

export const FavoritesIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="34" viewBox="0 0 35 34" fill="none">
        <path
            d="M24.7887 18.6004C26.0394 17.2893 26.9199 15.9696 27.4381 14.6425C27.9455 13.3434 28.1012 12.1713 27.9207 11.1163C27.7411 10.0661 27.2779 9.15269 26.5191 8.35724C25.7636 7.56523 24.8907 7.03455 23.8884 6.75535C22.8852 6.47589 21.8919 6.47589 20.8929 6.75515C19.8956 7.03395 19.0295 7.56369 18.2795 8.35724C17.8603 8.79671 17.505 9.29215 17.2125 9.84555L16.4896 11.2131L15.7668 9.84555C15.4743 9.29215 15.119 8.79671 14.6997 8.35724C13.9528 7.57426 13.0867 7.05001 12.089 6.77478C11.0884 6.49876 10.0955 6.49876 9.0949 6.77478C8.09716 7.05001 7.2311 7.57426 6.48065 8.36091C5.91241 8.94932 5.51126 9.61602 5.27068 10.369C5.02731 11.1307 4.95237 11.9382 5.04757 12.7994C5.14326 13.6649 5.45048 14.597 5.97619 15.5951C6.51104 16.6106 7.24808 17.6124 8.19062 18.6004L16.4896 27.3245L24.7887 18.6004ZM17.4853 29.134L17.3744 29.232C17.1 29.435 16.8074 29.5537 16.4893 29.5537C16.1081 29.5537 15.7583 29.4118 15.4933 29.134L6.67614 19.8652C5.59495 18.7319 4.73714 17.5659 4.10526 16.3662C3.46391 15.1485 3.07726 13.9755 2.95246 12.8466C2.82716 11.7131 2.92784 10.6284 3.25625 9.60048C3.58755 8.56358 4.14227 7.64163 4.91006 6.84663C5.89446 5.81472 7.05812 5.11031 8.38811 4.74342C9.71516 4.37734 11.0501 4.37734 12.3771 4.74342C13.7071 5.11031 14.8708 5.81472 15.8552 6.84663C16.0808 7.08318 16.2922 7.33217 16.4892 7.59347C16.6857 7.3328 16.8962 7.08471 17.1206 6.84955C18.1046 5.80828 19.2683 5.09652 20.5987 4.72463C21.9273 4.35322 23.2661 4.35322 24.5987 4.72442C25.9322 5.0959 27.1013 5.80669 28.0933 6.84663C29.1152 7.91778 29.755 9.17963 30.0001 10.6129C30.2444 12.0411 30.0408 13.574 29.4053 15.2013C28.7812 16.7996 27.7445 18.3534 26.3028 19.8648L17.4853 29.134Z"
            fill="url(#paint0_linear_4382_10375)"
            stroke="url(#paint1_linear_4382_10375)"
            strokeWidth="0.45"
        />
        <defs>
            <linearGradient
                id="paint0_linear_4382_10375"
                x1="30.1004"
                y1="9.82492"
                x2="4.01544"
                y2="25.9758"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF6666" />
                <stop offset="1" stopColor="#E646B6" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_4382_10375"
                x1="30.1004"
                y1="9.82492"
                x2="4.01544"
                y2="25.9758"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF6666" />
                <stop offset="1" stopColor="#E646B6" />
            </linearGradient>
        </defs>
    </svg>
)
